module.exports = __webpack_public_path__ + "img/sync-off-blue.f2c5df1f.svg";